export function progressState(lastLoaded, fileSize) {
    return {
        percentage: Math.floor((100 * lastLoaded) / fileSize),
        loaded: lastLoaded,
        total: fileSize,
    };
}
//# sourceMappingURL=progressState.js.map